module.exports = __webpack_public_path__ + "img/history.97590d89.png";